




















import VueOptions from '@utils/VueOptions'
import VendorListingDetail from '@ui/VendorListing/VendorListingDetail'
import MiniCalendar from '@ui/Calendar/MiniCalendar'
import VendorListingsPricingDisplay from '@ui/Campaign/pipeline/EventFeed/activation/VendorListingsPricingDisplay'

settings =
  name: 'VendorListingShow'

  resources:
    vendor_listing:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings/:vendorListingId'

    cart:
      resourceName: 'shopping_cart'
      slug: 'campaigns/:campaignId/shopping_cart'
      lazy: true

    activation_plan:
      resourceName: 'activation_plan'
      slug: 'campaigns/:campaignId/activation_plans/:activationPlanId'
      fetch: false

  vue:
    components: {
      VendorListingDetail,
      MiniCalendar,
      VendorListingsPricingDisplay,
    }

    computed:
      activationPlanId: -> "#{@$route.params.campaignId}:#{@vendorListingId}"
      vendorListingId: -> @$route.params.vendorListingId
      lineItems: -> @cart?.line_items || []

      vendorListingLineItem: ->
        @lineItems.find((lineItem) =>
          sameId = @ctxVendorListing(lineItem).id is @vendorListingId
          lineItem.is_professional_service and sameId
        )

      detailActions: ->
        close: @closeModal

    methods:
      closeModal: ->
        @$router.push @$route.path.split('/pro-services/')[0]

export default VueOptions.vue settings
